import { loadStripe } from '@stripe/stripe-js';

interface Window {
  clutter: {
    config?: {
      stripe: {
        stripePublishableKey: string;
      };
    };
  };
}

const STRIPE_PUBLISHABLE_KEY: string = (window as any).clutter.config?.stripe.stripePublishableKey;

export const STRIPE = loadStripe(STRIPE_PUBLISHABLE_KEY);
